import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

// Function to get roles
export function getRolesListRoot() {
    return axios.get(`${API_URL}/v1/rol/listroot`);
}

// Function to get tenants list
export function getTenantList() {
    return axios.get(`${API_URL}/v1/tenant/list`);
}

// Function to get features
export function getFeaturesList() {
    return axios.get(`${API_URL}/v1/features`);
}

// Function to create a new tenant
export function createTenant(tenantData: any) {
    return axios.post(`${API_URL}/v1/tenant`, tenantData);
}

// Function to create a root user
export function createRootUser(rootUserData: any) {
    return axios.post(`${API_URL}/v1/auth0/create-root`, rootUserData);
}

// Function to update tenant by OrgID
export function updateTenantByOrgID(orgId: string, tenantData: any) {
    return axios.put(`${API_URL}/v1/tenant`, tenantData, {
        params: { orgId: orgId }
    });
}

// NEW Function to create a tenant and root user in a single request
export function createRootTenant(data: any) {
    return axios.post(`${API_URL}/v1/tenant/create-root-tenant`, data);
}

// **NEW Function to delete a tenant by tenantId**
export function deleteTenantById(tenantId: string) {
    return axios.delete(`${API_URL}/v1/tenant/delete`, {
        params: { tenantId: tenantId }
    });
}
